import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/arrow-caret-up.svg'


const _hoisted_1 = { class: "pt-[12px] w-full md:w-max" }
const _hoisted_2 = { class: "w-full md:w-max" }
const _hoisted_3 = { class: "flex mb-[12px] max-md:hidden" }
const _hoisted_4 = { class: "w-full flex justify-end" }
const _hoisted_5 = { class: "w-full md:w-max" }
const _hoisted_6 = { class: "flex w-full md:w-max items-start gap-[6px] max-md:flex-col max-md:w-full max-md:gap-[12px] md:px-[12px]" }
const _hoisted_7 = { class: "bg-[#E5E4E2] flex flex-col px-[4.5px] py-[6px] rounded-primary-radius w-full" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "w-6 h-6 flex items-center justify-center bg-[#D3D1CD] p-2 rounded-primary-radius" }
const _hoisted_10 = { class: "text-xs font-medium text-primary-text-color" }
const _hoisted_11 = { class: "text-base md:text-xs font-medium text-primary-text-color" }
const _hoisted_12 = {
  key: 0,
  class: "w-full h-[calc(5*112px)] overflow-y-auto max-md:h-auto max-md:py-[6px]"
}
const _hoisted_13 = {
  key: 0,
  class: "mt-[6px]"
}

import ProjectCard from "@/components/Card/ProjectCard.vue";
import { Project, Status } from "@/types";
import {
  computed,
  ref,
  onMounted,
  onUnmounted,
} from "vue";

type Props = {
  statusList: Status[];
  allStatuses: Status[];
  projectList: Project[];
  selectedViewOptions: string[];
  nameFilter: string[];
};

type Emits = {
  (event: "toggleStatusOpen", statusId: number): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'MainContent',
  props: {
    statusList: {},
    allStatuses: {},
    projectList: {},
    selectedViewOptions: {},
    nameFilter: {}
  },
  emits: ["toggleStatusOpen"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const viewOptions = computed(() => [...props.selectedViewOptions]);

const filteredProjectsForStatus = (statusId: number) => {
  return props.projectList.filter((project: Project) => {
    const matchesStatus = project.statusId === statusId;
    const matchesType = viewOptions.value.length
      ? viewOptions.value.includes(project.type)
      : true;
    const matchesName =
      props.nameFilter.length === 0 ||
      props.nameFilter.includes(project.customer.name);

    return matchesStatus && matchesType && matchesName;
  });
};

const screenWidth = ref(window.innerWidth);
const currentPage = ref(0);

// Handle resizing
const updateScreenWidth = () => {
  screenWidth.value = window.innerWidth;
};
onMounted(() => window.addEventListener("resize", updateScreenWidth));
onUnmounted(() => window.removeEventListener("resize", updateScreenWidth));

// Compute how many columns fit per page
const columnsPerPage = computed(() => {
  if (screenWidth.value >= 1400) return 8;
  if (screenWidth.value <= 1399 && screenWidth.value >= 1234) return 7;
  if (screenWidth.value <= 1233 && screenWidth.value >= 1068) return 6;
  if (screenWidth.value <= 1067 && screenWidth.value >= 902) return 5;
  if (screenWidth.value <= 901 && screenWidth.value >= 768) return 4;
  if (screenWidth.value <= 767) return 8;
  return 1;
});

// Compute the total number of pages
const totalPages = computed(() =>
  Math.ceil(
    (props.statusList.length > 0
      ? props.statusList.length
      : props.allStatuses.length) / columnsPerPage.value
  )
);

// Get the current slice of visible columns
const visibleStatuses = computed(() => {
  const list =
    props.statusList && props.statusList.length > 0
      ? props.statusList
      : props.allStatuses;

  const start = currentPage.value * columnsPerPage.value;
  const end = start + columnsPerPage.value;
  return list.slice(start, end);
});

// Navigation
const goNext = () => {
  if (currentPage.value < totalPages.value - 1) currentPage.value++;
};
const goBack = () => {
  if (currentPage.value > 0) currentPage.value--;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!(currentPage.value === 0))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: goBack,
              class: "px-[16px] h-[16px] flex items-center justify-center"
            }, " ← "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (!(currentPage.value >= totalPages.value - 1))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: goNext,
                class: "px-[16px] h-[16px] flex items-center justify-center"
              }, " → "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleStatuses.value, (status) => {
            return (_openBlock(), _createElementBlock("div", {
              key: status.id,
              class: "h-fit max-w-[160px] min-w-[160px] max-md:w-full max-md:max-w-[1000px]"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  onClick: ($event: any) => (emit('toggleStatusOpen', status.id)),
                  class: "flex w-full items-center justify-between px-[5px] cursor-pointer"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(filteredProjectsForStatus(status.id).length
                        ? filteredProjectsForStatus(status.id).length
                        : 0), 1)
                  ]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(status.name), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      class: _normalizeClass(["cursor-pointer", status.isOpen ? 'rotate-180' : '0']),
                      src: _imports_0,
                      alt: ""
                    }, null, 2)
                  ])
                ], 8, _hoisted_8),
                (status.isOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProjectsForStatus(status.id), (project) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: project.id
                        }, [
                          (
                      project.statusId === status.id &&
                      (__props.nameFilter.length === 0 ||
                        __props.nameFilter.includes(project.customer.name))
                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(ProjectCard, {
                                  "project-id": project.id,
                                  customer: project.customer,
                                  name: project.name,
                                  phases: project.phases,
                                  statusId: project.statusId
                                }, null, 8, ["project-id", "customer", "name", "phases", "statusId"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})